// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rq-c";
export var backButton = "_rq-4";
export var backIcon = "_rq-5";
export var chevronShortcut = "_rq-6";
export var container = "_rq-1";
export var editor = "_rq-8";
export var editorWrapper = "_rq-7";
export var prefix = "_rq-2";
export var searchIcon = "_rq-3";
export var suffix = "_rq-9";
export var suffixContent = "_rq-a";
export var suffixText = "_rq-b";
export var wrapper = "_rq-0";